module.exports = __webpack_public_path__ + "img/imgDel.eb9a1a66.svg";